import React, { useEffect, useState } from 'react'
import ControlTaskComponent from '../task/ControlTask'
import EditTaskComponent from '../task/EditTask'
import { ITask } from '../task/Task'
import {
    addTask,
    CREATE_TASK,
    isTaskCreatePayloadAction,
} from '../../flux/tasks/TaskActions'
import Dispatcher, { IAction } from '../../flux/Dispatcher'

/**
 * Properties required by the ControlSwimlaneTasks component
 */
export interface IControlSwimlaneTasksProps {
    boardId: number
    swimlaneId: number
    taskIds: number[]
}

function ControlSwimlaneTasksComponent(props: IControlSwimlaneTasksProps) {
    const _task: ITask = { id: -1, order: -1, name: '', description: '' }
    const [isAdd, setAdd] = useState(false)

    function handleCancel() {
        setAdd(false)
    }

    function handleSave(task: ITask) {
        addTask(props.boardId, props.swimlaneId, task)
    }

    useEffect(() => {
        /**
         * Determines if action is ITaskCreate action
         * If so determines if it's for this board and swimlane.
         * If so then toggles the state
         * @param action Action
         */
        function handleAddTaskAction(action: IAction) {
            if (!isTaskCreatePayloadAction(action)) return false
            if (
                !(
                    action.payload.boardId === props.boardId &&
                    action.payload.swimlaneId === props.swimlaneId
                )
            )
                return false
            if (action.actionType !== CREATE_TASK) return false
            setAdd(true)
        }

        const handle = Dispatcher.register(handleAddTaskAction)
        return () => {
            Dispatcher.unregister(handle)
        }
    }, [isAdd, props.boardId, props.swimlaneId])

    return (
        <>
            {isAdd && (
                <EditTaskComponent
                    task={_task}
                    onCancel={handleCancel}
                    onSave={handleSave}
                />
            )}
            {props.taskIds.map((task, index, array) => (
                <div
                    className={index === array.length - 1 ? 'mb-5' : 'mb-2'}
                    key={task}>
                    <ControlTaskComponent
                        boardId={props.boardId}
                        swimlaneId={props.swimlaneId}
                        taskId={task}
                    />
                </div>
            ))}
        </>
    )
}

export default ControlSwimlaneTasksComponent
